// extracted by mini-css-extract-plugin
export default {"pane":"panes_pane__WG9Tr","paneWide":"panes_paneWide__rdHXb"};